import { Link } from "react-router-dom";

export default function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row gx-0">

          {/* ========== LEFT COLUMN ========== */}
          <div className="col-lg-6 d-flex flex-column justify-content-center">
            <div className="content" data-aos="fade-up" data-aos-delay="200">

              <h3>Who We Are</h3>

              <h2>
                At SDtech Solutions, we are a team of passionate professionals
                dedicated to helping businesses thrive in the digital landscape.
              </h2>

              <p>
                We specialize in Software Development, Web & Mobile App Development,
                Digital Marketing, UI/UX Design, Cloud Services, and AI Solutions.
                Our mission is to transform your ideas into powerful digital products
                that drive real business results.
              </p>

              <p>
                Choose SDtech Solutions as your technology partner and unlock the full
                potential of your digital presence. Together, we can turn your vision
                into reality.
              </p>

              <div className="text-center mb-5 text-lg-start">
                <Link
                  to="/about"
                  className="btn-read-more d-inline-flex align-items-center justify-content-center align-self-center"
                >
                  <span className="text-light "> Read More</span>
                  <i  className="bi bi-arrow-right text-light" />
                </Link>
              </div>

            </div>
          </div>

          {/* ========== RIGHT COLUMN ========== */}
          <div
            className="col-lg-6  d-flex align-items-center aboutimg col-sm-12"
            data-aos="zoom-out"
            data-aos-delay="200"
          >
            <img
              src="img/about1.jpg"
              className="img-fluid mt-5 img-responsive"
              alt="About SDtech Solutions"
              style={{ backgroundSize: "cover" }}
            />
          </div>

        </div>
      </div>
    </section>
  );
}